var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMinus = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  id: "svg421",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Plus"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M 11,11 H 4 C 3.73478,11 3.48043,11.1054 3.29289,11.2929 3.10536,11.4804 3,11.7348 3,12 3,12.2652 3.10536,12.5196 3.29289,12.7071 3.48043,12.8946 3.73478,13 4,13 h 7 c 4.160503,0.0549 1.098591,0.01736 9,0 0.2652,0 0.5196,-0.1054 0.7071,-0.2929 C 20.8946,12.5196 21,12.2652 21,12 21,11.7348 20.8946,11.4804 20.7071,11.2929 20.5196,11.1054 20.2652,11 20,11 c -6.752393,-0.0026 -4.942392,0.0619 -9,0 z",
  fill: "currentColor"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMinus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/minus.ef0eab78ef8b7cbca4658417d9a36fd3.svg";